export default __webpack_public_path__ + "static/media/1.90f9b87b.svg";